import { gql } from '@apollo/client';

export const IMPORT_CONTACTS_CSV = gql`
    mutation ImportContactsCsv($input: ImportContactsCsvInput!) {
        importContactsCsv(input: $input) {
            created
            skipped
            updated
            skippedMissingName
            updatedExisting
            tagsCreated
        }
    }
`;
